import { useState, useEffect } from "react";
import getCookie from "../helper/getCookie";
import getDecryptData from "../helper/getDecryptData";
import axiosInstance from "../axiosInstance";
import eraseCookie from "../helper/eraseCookie";

const useAuthValid = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const AuthValid = async () => {
    const authuser = getCookie("token");
    if (!authuser) {
      setLoading(false);
      return;
    }

    try {
      const decryptdatajson = await getDecryptData();
      const id = decryptdatajson?._id;

      const { data } = await axiosInstance.post("/auth-user", { id });

      if (data.success) {
         setUser(data.existingUser);
      } else {
        eraseCookie("token");
        setUser(null);
      }
    } catch (err) {
      console.error(err);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  // ✅ run only once
  useEffect(() => {
    AuthValid();
  }, []);

  return {
    user,
    loading,
    isAuthenticated: !!user,
  };
};

export default useAuthValid;
